import { Component, Input, ViewChild, ElementRef, Inject, OnInit, AfterViewInit} from '@angular/core';
import { MarketingMessagesManagerService } from '../services';
import {MarketingMessagesManagerLayoutsComponent} from './marketing-messages-manager-layouts/marketing-messages-manager-layouts.component';
// import * as jQuery from 'jquery';
declare var $: any;
import * as CONSTANTS  from '../constants';
import { DOCUMENT } from '@angular/common';
import  '../js/MarketingClickStream.js';

declare var marketing_view: any;
declare var fireMarketingCustomEvent:any;
@Component({
  selector: 'pru-marketing-messages',
  templateUrl: './marketing-messages-manager.component.html',
  styleUrls: ['./marketing-messages-manager.component.scss']
})

export class MarketingMessagesManagerComponent implements OnInit, AfterViewInit {
  @ViewChild('pruMarketingMessages') pruMarketingMessages: ElementRef;
  @ViewChild('marketingMessagesManagerLayoutsComponent') marketingMessagesManagerLayoutsComponent: MarketingMessagesManagerLayoutsComponent;
 
  @Input() appName:string;
  @Input() slotName:string;
  @Input() topMarginRequired:string;
  @Input() retirementLink:string="";

  public marketingSlotsContent : any[];
  isErrResponse:boolean=false;
  enableMarketingMessage:boolean=false;
  isShowContent:boolean=false;
  responseBody: any;
  marginTop:string;
  contentId:string;
  id:string;
  hasJsonResponse:boolean=false;
  isEmptyRetirementLink:boolean=false;
  
  
  constructor(    
    private contentJson: MarketingMessagesManagerService ,
    @Inject(DOCUMENT) private document, 
    private elementRef: ElementRef   
  ) {
    
  }

  ngOnInit(): void {
    this.getJsonContent();
    
  }

  /*
    Retrieve the json data from backend
   */
  getJsonContent(): void {
    this.contentJson.getContentInfo(this.appName, this.slotName).subscribe((res) => {
    console.log('res = ', res); 
    this.getSlotResponse(res);
    
    },
    (err)=>{
        this.isErrResponse = true;
    }
  )}

  getSlotResponse(response:any):void{
    if(!(response.hasOwnProperty('body'))){
      this.isErrResponse = true;
      
    } else {
      this.responseBody = response.body;
      if((this.isEmptyObject(this.responseBody))){
        this.isErrResponse = true;
      } else{
        this.marketingSlotsContent= this.responseBody.marketingSlotsContent;
        this.enableMarketingMessage = this.responseBody.enableMarketingMessages;
        this.contentId = this.responseBody.contentID;
        if(this.checkForEmptyRetirementLink(this.contentId)){
          this.isEmptyRetirementLink=true;
        }
        var str=CONSTANTS.MMM_ID;
        this.id=str.concat(this.contentId);
        this.addMarginTop();
        this.hasJsonResponse=true;
        if(!this.isEmptyRetirementLink && this.enableMarketingMessage && window.performance.navigation.type != 1){
          marketing_view(this.contentId);
        }

      }

  }
  }

  isEmptyObject(obj) {
    return !Object.keys(obj).length;
  }

  addMarginTop():void{
    if(this.topMarginRequired=='Y'){
      this.marginTop='top-margin';
    }
  }

  checkForEmptyRetirementLink(contentId):boolean{
    if(this.appName==CONSTANTS.MYPRU_APPNAME &&(this.contentId==CONSTANTS.MMM_0001||this.contentId==CONSTANTS.MMM_0003)&& this.retirementLink==''){
      return true;
    }
    return false;
  }

//Fire Custom Event For Adobe Analytics Tagging
ngAfterViewInit():void{
  setTimeout(() => {
  if(!this.isEmptyRetirementLink && this.hasJsonResponse && (window.sessionStorage.getItem("marketingCustomEvent")==null || window.sessionStorage.getItem("marketingCustomEvent")=="" )){
    window.sessionStorage.setItem("marketingCustomEvent","Y");
      
        fireMarketingCustomEvent();
      }
    },700)
 }

}


